/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_ManagementInputs */



/**
* | output |
* | --- |
* | "Team Management" |
*
* @param {Team_ManagementInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_management = /** @type {((inputs?: Team_ManagementInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_ManagementInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gestion d'équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teammanagement")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestione del team")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление командой")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gestión de equipos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("团队管理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームマネジメント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम प्रबंधन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gestão de Equipes")
	return /** @type {LocalizedString} */ ("Team Management")
});